import { Select } from "antd";
import  { forwardRef, useEffect, useState } from "react";
import apiClient from "../../services/api";

const { Option } = Select;

const SelectAjax = forwardRef((props: any, ref) => {
    const [options, setOptions] = useState([]);
    const { url, displayProp, valueProp, onNew, value, onChange, ...rest } = props;
  
    const getValues = async () => {
      const res = await apiClient.get(url);
      const values = [{ id: "", name: "Selecciona" }, ...(res?.data ?? [])];
      setOptions(values);
    };
  
    useEffect(() => {
      getValues();
    }, [url]);
  
    const handleChange = (val, option) => {
      if (val === "__new__") {
        if (onChange) onChange(undefined);
        if (onNew) onNew();
      } else {
        if (onChange) onChange(val, option);
      }
    };
  
    return (
      <Select
        placeholder="Selecciona"
        allowClear
        showSearch
        filterOption={(input, option: any) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        value={value}
        onChange={handleChange}
        ref={ref}
        {...rest}
      >
        {options.map((a) => (
          <Option key={a[valueProp] ?? a.id} value={a[valueProp] ?? a.id}>
            {a[displayProp] ?? a.name}
          </Option>
        ))}
        <Option key="__new__" value="__new__">
          + Nuevo
        </Option>
      </Select>
    );
  })
  
  export default SelectAjax ;